/**
 * The shared key-value store for collaborative COP state.
 *
 * Commander's intent, mission phase, a shared note — small values the whole
 * team reads and plans against, so they live on the server and everyone sees
 * the same thing. Viewer reads; operator writes.
 */

import { api, type ApiResult } from '@/api/client';

export interface SharedValue {
  value: string;
  updatedBy: string;
  updatedAt: number;
}

export function getSharedState(): Promise<ApiResult<{ state: Record<string, SharedValue> }>> {
  return api.get<{ state: Record<string, SharedValue> }>('/state', { logged: false });
}

export function setSharedState(key: string, value: string): Promise<ApiResult<unknown>> {
  return api.put(`/state/${encodeURIComponent(key)}`, { value }, { label: `STATE ${key}` });
}
